import i18n from "@/plugins/i18n";
import { ComplaintExpectationType } from "./complaintExpectationType";

export interface IComplaintExpectationType {
	text: string;
	value: ComplaintExpectationType;
}

export function getComplaintExpectationTypes(): IComplaintExpectationType[] {
	return [
		{
			text: i18n.t("dtoLabels.complaintExpectationType.ersatzlieferung") as string,
			value: ComplaintExpectationType.Ersatzlieferung,
		},
		{
			text: i18n.t("dtoLabels.complaintExpectationType.other") as string,
			value: ComplaintExpectationType.Other,
		},
	];
}
